import React from "react";
import { Card, Form } from "react-bootstrap";

interface FilterSearchProps {
    header?: boolean;
    data: Array<{ name: string; data: string[] }>;
    filterStore: Array<{ [key: string]: string }>;
    onFilter: (filter: Array<{ [key: string]: string }>) => void;
    isLoading: boolean;
    border?: boolean;
    mt?: number | string;
}

export const FilterSearch: React.FC<FilterSearchProps> = (
    { header, data, filterStore, onFilter, isLoading, border }
) => {
    if (!data || data.length === 0) {
        return null;
    }

    const filterAdd = (group: string, item: string, checked: boolean) => {
        const obj = { [group]: item };
        const filter = checked
            ? [...filterStore, obj]
            : filterStore.filter(f => JSON.stringify(f) !== JSON.stringify(obj));

        onFilter(filter);
    };

    return (
        <Card className={`${border ? 'b-theme-primary' : 'border-0'}`}>
            {header && <Card.Header className='bg-theme-primary text-light text-uppercase fw-bold p-none'>Filtros</Card.Header>}
            <Card.Body>
                {data.map((group, index) => (
                    <div key={index}>
                        <Card.Title className="text-capitalize">{group.name}</Card.Title>
                        <Card.Text>
                            <Form>
                                {group.data.map((item) => (
                                    <Form.Check
                                        key={`default-${item}`}
                                        className="mb-3 text-capitalize"
                                        style={{ cursor: "pointer" }}
                                        type='checkbox'
                                        id={`default-${item}`}
                                        label={item}
                                        onChange={(e) => filterAdd(group.name, item, e.target.checked)}
                                        disabled={isLoading}
                                    />
                                ))}
                            </Form>
                        </Card.Text>
                    </div>
                ))}
            </Card.Body>
        </Card>
    );
};
